// XXX: THE one question every element answers about itself: "am I configured
// XXX: so that I will render?" An element type declares `configurationProblems`
// XXX: on its component definition and returns a list of author-facing
// XXX: sentences; returning [] means valid. Declaring nothing means valid.
// XXX: PURE ON PURPOSE -- no Vue instance, no store, no window. The builder
// XXX: calls it per element on load and on every option change, and a compile
// XXX: pass can call the same function over the same tree and get the same
// XXX: answer. Two callers, one rule; that is the whole point.
// XXX: A validator that throws is itself a defect: it is reported as a problem
// XXX: naming the element type, never allowed to take the layers panel down.

// XXX: `elementDef` is the RAW component object, so a validator declared on a
// XXX: shared mixin (DcHostMixin covers all eleven DC hosts,
// XXX: DynamicElementWithContext covers every context-bound element) is NOT on
// XXX: it -- Vue merges mixins at instance creation, not into the definition.
// XXX: Resolve them the way Vue would: the definition, then its mixins, then
// XXX: its `extends` chain.
// XXX: EVERY validator in the chain runs and their problems CONCATENATE. This
// XXX: used to return the FIRST one found, so an element type declaring its own
// XXX: rule (DynamicAppFeedElement) silently SHADOWED the mixin rules it also
// XXX: inherits -- a feed with a dangling context binding reported only the feed
// XXX: problem, and the binding stayed invisible.
function collectValidators(definition, seen = new Set(), found = []) {
  if (!definition || seen.has(definition)) {
    return found;
  }
  seen.add(definition);
  if (typeof definition.configurationProblems === "function") {
    found.push(definition.configurationProblems);
  }
  for (const mixin of definition.mixins ?? []) {
    collectValidators(mixin, seen, found);
  }
  return collectValidators(definition.extends, seen, found);
}

function elementConfigurationProblems(element, dynamicComponent = null, contextEntities = {}) {
  const elementDef = element?.elementDef;
  const validators = collectValidators(elementDef);
  if (!validators.length) {
    return [];
  }
  const label = elementDef?.name ?? element?.type ?? "element";
  const problems = [];
  for (const validate of validators) {
    try {
      const found = validate({ element, dynamicComponent, contextEntities });
      if (!Array.isArray(found)) {
        continue;
      }
      problems.push(...found.map(problem => String(problem)).filter(Boolean));
    } catch (error) {
      problems.push(
        `${label} could not validate its own configuration (${error?.message ?? error}). `
        + "This is a defect in the element, not in the page — report it.",
      );
    }
  }
  return problems;
}

function collectBuilderLoadRepairs(definition, seen = new Set(), found = []) {
  if (!definition || seen.has(definition)) {
    return found;
  }
  seen.add(definition);
  if (typeof definition.repairOnBuilderLoad === "function") {
    found.push(definition.repairOnBuilderLoad);
  }
  for (const mixin of definition.mixins ?? []) {
    collectBuilderLoadRepairs(mixin, seen, found);
  }
  return collectBuilderLoadRepairs(definition.extends, seen, found);
}

function runBuilderLoadRepairs(definition, identifier) {
  return collectBuilderLoadRepairs(definition).every(repair => repair({ identifier }) !== false);
}

module.exports = { elementConfigurationProblems, runBuilderLoadRepairs };
module.exports.default = module.exports;

